import { render } from "./VitrineNav.vue?vue&type=template&id=1ae48b6d&scoped=true"
import script from "./VitrineNav.vue?vue&type=script&lang=js"
export * from "./VitrineNav.vue?vue&type=script&lang=js"

import "./VitrineNav.css?vue&type=style&index=0&id=1ae48b6d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae48b6d"]])

export default __exports__